import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router
} from '@angular/router';
import { AuthService } from '../services/auth/auth.service'; // Adjust the path if needed

@Injectable({
  providedIn: 'root'
})
export class TherapistAuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const user = this.authService.getAuthUserRecordFromLocalStorage(); // Assume this returns user object or null

    if (user && user.user.userTypeID === 3) {
      console.log("canActivate:user is ok");
      return true;
    } else {
      console.log("canActivate:navigate to client portal");
      this.router.navigate(['client-portal']);
      return false;
    }
  }
}
